

export const Resource = {
    npmInstall: "npm i @okta/okta-react @okta/okta-auth-js",
    env: `REACT_APP_OKTA_CLIENTID=0oa1j6x7jbkDhBHsk0h8
REACT_APP_OKTA_APP_REDIRECT_URL=/login/callback
REACT_APP_OKTA_ISSUER=https://insidebrady.okta.com/oauth2/default`,
    devenv: `HTTPS=true
PORT=44308

REACT_APP_OKTA_CLIENTID=0oa1j6x7jbkDhBHsk0h8
REACT_APP_OKTA_APP_REDIRECT_URL=/login/callback
REACT_APP_OKTA_ISSUER=https://insidebrady.okta.com/oauth2/default`,
setupImport:`import {Routes, Route, useNavigate } from 'react-router-dom';
import { Security, LoginCallback, useOktaAuth } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';`,
setupOkta:`const issuer = process.env.REACT_APP_OKTA_ISSUER;
const clientId = process.env.REACT_APP_OKTA_CLIENTID;
const redirect = process.env.REACT_APP_OKTA_APP_REDIRECT_URL;

const oktaAuth = new OktaAuth({
  issuer: issuer,
  clientId: clientId,
  redirectUri: window.location.origin + redirect
});`,
setupAppTopLevel:`const history = useNavigate(); //BrowserRouter must be a Ancestor/Parent to any component using this

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  history(toRelativeUrl(originalUri || '/', window.location.origin), {replace: true})
};`,
setupAppReturn:`<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} >
<div className="App">
  <main>
    <Routes>
      <Route path="/login/callback" element={<LoginCallback/>} />
    </Routes>
  </main>
</div>
</Security>`,
button: `import {Navbar, Nav, Form, Button} from "react-bootstrap"
import {LinkContainer} from 'react-router-bootstrap'


import { useOktaAuth } from "@okta/okta-react";

export const Component = () => {
  const { authState, oktaAuth } = useOktaAuth();


  if (authState?.isPending) {
    return <div>Loading...</div>;
  }

  const button = authState?.isAuthenticated ? (
    <Button
      variant="secondary"
      onClick={() => {
        oktaAuth.signOut("/");
      }}
    >
      Logout
    </Button>
  ) : (
    <Button
      variant="secondary"
      onClick={() => {
        oktaAuth.signInWithRedirect();
      }}
    >
      Login
    </Button>
  );

  return (
      <Form className="loginForm">{button}</Form>
  );
};`,
forcelogin:`import { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";
import UserProfile from "../Components/UserProfile";

const Profile = () => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    async function authenticate() {
      if (!authState) return;

      if (!authState.isAuthenticated) {
        await oktaAuth.signInWithRedirect();
      }
    }

    authenticate();
  }, [authState, oktaAuth]);

  if (!authState?.isAuthenticated) {
    return (
      <Container>
        <p>Please wait while we sign you in</p>
      </Container>
    );
  } else {
    return (
      <Container>
        <UserProfile/>
      </Container>
    );
  }
};

export default Profile;`,
redirect:`import { Navigate } from 'react-router-dom';
import { Container, Row, Col, Card } from "react-bootstrap";
import { useOktaAuth } from "@okta/okta-react";

const RedirectPage = () => {
  const { authState, oktaAuth } = useOktaAuth();

  return !authState?.isAuthenticated ? (
    <Navigate to="/" />
  ) : (
    <Container>
      <Row>
        <Col className="text-center">
            <Card style={{ margin: "1em auto", height: "160px" }}>
                <Card.Header>You are Logged In</Card.Header>
                <Card.Body>
                    If you wree not logged in, you would have been redirected to the home page.
                </Card.Body>
            </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default RedirectPage`,
profile:`import React, { useState, useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Row, Col } from "react-bootstrap";

const UserProfile = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      setUserInfo(authState.idToken.claims);
      // You can also get user information from the \`/userinfo\` endpoint
      /*oktaAuth.getUser().then((info) => {
        setUserInfo(info);
      });*/
    }
  }, [authState, oktaAuth]); // Update if authState changes

  if (!userInfo) {
    return (
      <div>
        <p>Fetching user profile...</p>
      </div>
    );
  }

  return (
        <>
            <Row>
                <Col>
                    <h3>User Profile (ID Token Claims)</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p>
                        Below is the information from your ID token which was obtained during the &nbsp;
                        <a href="https://developer.okta.com/docs/guides/implement-auth-code-pkce">PKCE Flow</a>
                        {' '}
                        and is now stored in local storage.
                        </p>
                        <p>
                        This page cannot be accessed until you have authenticated.
                    </p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <table>
                        <thead>
                            <tr>
                            <th>Claim</th>
                            <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(userInfo).map((claimEntry) => {
                            const claimName = claimEntry[0];
                            const claimValue = claimEntry[1];
                            const claimId = \`claim-\${claimName}\`;
                            return (
                                <tr key={claimName}>
                                <td>{claimName}</td>
                                <td id={claimId}>{claimValue.toString()}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </table>
                </Col>
            </Row>
        </>
  );
};

export default UserProfile;`,
appContent:`import './App.css';
import {Routes, Route, useNavigate } from 'react-router-dom';

import { Security, LoginCallback, useOktaAuth } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

import Home from "./Pages/Home";
import Profile from "./Pages/Profile";
import Instructions from "./Pages/Instructions";
import RedirectPage from "./Pages/RedirectPage";
import Header from "./Components/Header";
import TestAPI from './Pages/TestAPI';
import { useEffect } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";

const issuer = process.env.REACT_APP_OKTA_ISSUER;
const clientId = process.env.REACT_APP_OKTA_CLIENTID;
const redirect = process.env.REACT_APP_OKTA_APP_REDIRECT_URL;

const oktaAuth = new OktaAuth({
  issuer: issuer,
  clientId: clientId,
  redirectUri: window.location.origin + redirect
});

function App() {

  const history = useNavigate(); //BrowserRouter must be a Ancestor/Parent to any component using this

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    history(toRelativeUrl(originalUri || '/', window.location.origin), {replace: true})
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} >
      <div className="App">
        <Header/>
        <main>
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/index.html" element={<Home/>} />
            <Route path="/redirect" element={<RedirectPage/>} />
            <Route path="/login/callback" element={<LoginCallback/>} />
            <Route path="/instructions" element={<Instructions/>} />
            <Route path="/profile" element={<Profile/>} />
            <Route path="/testapi" element={<TestAPI/>} />
          </Routes>
        </main>
      </div>
    </Security>
  );
}

export default App;`,
useAPI:`import { useOktaAuth } from "@okta/okta-react";

//In Component or Hook
const { authState, oktaAuth } = useOktaAuth();

//Get Token for API Call
let token = authState?.isAuthenticated ? authState.accessToken.accessToken : "";

//Add to Request Headers
const response = await fetch("https://bradycustomlockdevapi.azurewebsites.net/api/" + endpoint,{
    headers: {
        //Authorization: 'Bearer ' + authState?.isAuthenticated ? authState.accessToken : ""
        Authorization: 'Bearer ' + token
    }
});`
}

